import { SVGProps } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {
  size?: number
}

export const InfoLetterIcon = ({ size = 24, ...props }: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 9h.01" />
    <path d="M11 12h1v4h1" />
  </svg>
)


